import { render, staticRenderFns } from "./Hazard.vue?vue&type=template&id=386914af"
import script from "./Hazard.vue?vue&type=script&lang=js"
export * from "./Hazard.vue?vue&type=script&lang=js"
import style0 from "./Hazard.vue?vue&type=style&index=0&id=386914af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports